import { render, staticRenderFns } from "./InstallmentPlanChannelEdit.vue?vue&type=template&id=697fd133&"
import script from "./InstallmentPlanChannelEdit.vue?vue&type=script&lang=js&"
export * from "./InstallmentPlanChannelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports